function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.88,8.81a1.27,1.27,0,0,0-1.07.64,2.58,2.58,0,0,0-.35,1.36C5.57,12,7,13,7.82,13.58c7.71,5.23,5.78,5.64,11.63,1.43,1.28-.93,3.07-1.86,3.85-3a2.27,2.27,0,0,0,.15-2.64c-.58-.64-1.08-.56-1.94-.56H8.57A11.92,11.92,0,0,0,6.88,8.81Z",
    style: {
      fill: "#eac282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.65,23A3,3,0,0,0,23.51,22a3.17,3.17,0,0,0-3.14,3.15,3,3,0,0,0,.42,1.63H18.51a4.09,4.09,0,0,0,.43-1.57A3.13,3.13,0,0,0,13.59,23a3.37,3.37,0,0,0-.86,2.24,3.2,3.2,0,0,0,.86,2.14,3.14,3.14,0,0,0,2.24.93h7.68a3.13,3.13,0,0,0,3-3.2,3.16,3.16,0,0,0-.9-2.11ZM17,26.22a1.72,1.72,0,0,1-1.15.49,1.71,1.71,0,0,1-1.57-1.57,1.54,1.54,0,0,1,.5-1.14,1.51,1.51,0,0,1,1.07-.43A1.63,1.63,0,0,1,17,24,1.68,1.68,0,0,1,17,26.22Zm7.56,0a1.51,1.51,0,0,1-1.07.49,1.57,1.57,0,0,1-1.14-.49,1.44,1.44,0,0,1-.43-1.08,1.5,1.5,0,0,1,1.42-1.57h.15a1.43,1.43,0,0,1,1.07.43A1.53,1.53,0,0,1,25,25.14a1.6,1.6,0,0,1-.45,1.08Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.94,23.22h-.07a2.93,2.93,0,0,0-.81-1.07,4.21,4.21,0,0,0-3-1.29,4.29,4.29,0,0,0-3,1.29,4,4,0,0,0-.75,1.07H7.16a1.63,1.63,0,0,1-1.64-1.29,7.7,7.7,0,0,1-.06-1.36V13.44c1.42,1.34,7.77,5.84,9.2,5.84s7.71-4.5,9.14-5.85v7.38h0a4.31,4.31,0,0,0-3.07,1.29A4.37,4.37,0,0,0,19.94,23.22Z",
    style: {
      fill: "#eac282"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemail);
export default __webpack_public_path__ + "static/media/voicemail.878a295c.svg";
export { ForwardRef as ReactComponent };